import { userService } from "../_services";

export const handleResponse = function(response) {
  

  
  const data = response.data;
  if (!(response.status === 200 || response.status === 201)) {
    if (response.status === 401) {
      // auto logout if 401 response returned from api
      userService.postlogout();
      location.reload(true);
    }

    const error = (data && data.message) || response.statusText;
    return Promise.reject(error);
  }
  
  
  return data;
};
